<template lang="pug">
  v-dialog(v-model="dialog" persistent max-width="680")
    v-icon(slot="activator" class='mr-2' title='PI Available' color="orange" flat) find_in_page
    v-card
      v-toolbar(dense dark color="primary")
        v-toolbar-title PI Tracking
      v-list(three-line subheader class="print-bg") 
        v-layout(row wrap)
          v-flex(xs12)
            v-data-table(
              :headers="headers"
              :items="pr"
              :pagination.sync="pagination"
              hide-actions
              class="elevation-1")
              template(slot="items" slot-scope="props")
                td(style="vertical-align:top;") {{ props.item.pr_number }}
                td(style="vertical-align:top;") {{ props.item.description }}
                td(style="vertical-align:top;") {{ props.item.status }}
                td(v-if="props.item.pr_number" style="vertical-align:top;")
                  v-btn(:href="props.item.link" small color="info" target="_blank") Track
                td(v-else) &nbsp;
      v-card-actions
        v-spacer
        v-btn(color="green darken-1" flat @click.native="dialog = false") Close
</template>

<script>
import axios from 'axios';
export default {
  name: "PiprTrack",
  props: {
    dialogType: String,
    imItems: Object,
    userDetail: Object
  },
  data: () => ({
    dialog: false,
    pagination: {
      sortBy: 'pr_number',
      descending: true
    },
    headers: [
      {
        text: 'PI Number',
        value: 'pr_number'
      },
      {
        text: 'PI Description',
        value: 'description'
      },
      {
        text: 'PI Status',
        value: 'status'
      },
      {
        text: 'Action',
        value: 'link'
      }
    ],
    pr: []
  }),
  computed: {
    dataPr: function() {
      if (typeof this.imItems.imPiNumber !== 'undefined') {
        let arrPr = [];
        arrPr.push({
          pr_number: this.imItems.imPiNumber,
          description: '-',
          status: '-',
          link: this.$store.state.ISEARCH_ADDRESS+'/?number='+this.imItems.imPiNumber+'&tipe=pi'
        });
        
        return arrPr;
      }
      return false;
    }
  },
  mounted() {
    this.getDesc();
  },
  methods: {
    getDesc: async function () {
      let result = [];
      if (this.dataPr.length) {
        for (const key in this.dataPr) {
          if (this.dataPr.hasOwnProperty(key)) {
            let config = {
              method: "get",
              url: this.$store.state.ISEARCH_URL+"/api/v1/search2?number="+this.dataPr[key].pr_number+"&tipe=pi&group=all&status=all",
              headers: {"api-token": "xkwazTWvZvikyNO8pZ3LmZAbUvvXYBPuZJ9H1rDpfAaMFcY3RLQjnRN4GvKD"}
            };
            let rs = await axios(config);
            if (rs.data.result === 'Data Not Found' && rs.data.status === 'errors') {
              this.dataPr[key].status = 'Reject';
            } else {
              this.dataPr[key].description = rs.data.result[0].pi_description;
              this.dataPr[key].status = rs.data.result[0].pi_release_date !== '0000-00-00' ? 'Release' : 'Outstanding';
            }
          }
        }
        result = this.dataPr;
      }
      
      this.pr = result;
    }
  }
};
</script>
